import { render } from "./ThreeSectionLayout.vue?vue&type=template&id=18f2998e&scoped=true"
import script from "./ThreeSectionLayout.vue?vue&type=script&lang=js"
export * from "./ThreeSectionLayout.vue?vue&type=script&lang=js"

import "./ThreeSectionLayout.vue?vue&type=style&index=0&id=18f2998e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f2998e"]])

export default __exports__